<dz-card [cardOptions]="{ isSelectable: false }" class="card">
	<div dzCardTitle class="justify-content-between d-flex card-container" *ngIf="chartData || tableData">
		<div class="text-20-bold heading-text line-height-28">
			<span class="title" dcrHTMLKey="{{ dcrOptions?.key }}">{{ dcrOptions?.default }}</span>
			<dz-icon *ngIf="tooltipDcr" type="info-circle" class="info-circle color-blk-purple text-14" [tooltip-dcr]="tooltipDcr"></dz-icon>
		</div>
		<div class="chart-toggle-container">
			<ac-chart-table-toggle [initialType]="toggleType.Chart" (newToggleStatus)="toggleChange($event)" [showIconView]="true"></ac-chart-table-toggle>
		</div>
	</div>

	<ng-container [ngSwitch]="componentState">
		<div dzCardContent *ngSwitchCase="toggleType.Chart" class="d-flex row justify-content-between">
			<div class="doughnut-chart-container col-24">
				<ac-chart
					*ngIf="chartData; else emptyTabData"
					[highChartsAttributes]="{
						chartType: 'iq-doughnut',
						tabData: chartData,
						portfolioIndex: 0,
						showTitle: false,
						useTooltip: true,
						ignoreEmpty: true
					}"
				>
				</ac-chart>
			</div>
		</div>

		<div dzCardContent *ngSwitchCase="toggleType.Table">
			<dl-display-table
				*ngIf="tableData; else emptyTabData"
				class="margin-horizontal-24"
				[data]="tableData"
				[tableOptions]="tableOptions"
				[columnClassOverride]="columnClassOverride"
			></dl-display-table>
		</div>
	</ng-container>

	<ng-template #emptyTabData>
		<div [dcrHTMLKey]="'TABLE_CHART_NO_DATA'">No data found to view.</div>
	</ng-template>
</dz-card>
